import React from 'react'
import CandidateEditProfileComponent from '../Components/CandidateEditProfileComponent'
import CandidateHeaderComponent from '../Components/CandidateHeaderComponent'

function CandidateEditProfilePage() {
  return (
    <div>
        {/* <CandidateHeaderComponent/> */}
        <CandidateEditProfileComponent/>
    </div>
  )
}

export default CandidateEditProfilePage